import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { graphic } from "echarts";
import { AuthMe } from "../lib/MyHttp";
import ECharts, { EChartsReactProps } from "echarts-for-react";
import useClientStore from "../stores/client";
import { useTranslation } from "react-i18next";
import alarm from "../assets/sound/beep1.mp3";
import { GetListLast } from "../lib/DeviceData";
import { calculateAge, checkCanPlay, gapTime, typeSex } from "../lib/Common";
import { Get,SearchDevice } from "../lib/Device";
import moment from "moment";

import UnUseIcon from '../assets/block.gif';
import UseIcon_c from '../assets/chair_use.gif';
import UseIcon_m from '../assets/location.gif';
import UseIcon_b from '../assets/goto_sleep.gif';
import UseIcon_s from '../assets/pillow.gif';
import Apnea_icon from '../assets/insomnia.gif';

import ttsAudio from "../assets/sound/tts_07.mp3"; // mp3 경로 import

import { Progress } from "antd";


const Start = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { client, addOnMessage, removeOnMessage } = useClientStore();
    const [audio] = useState(new Audio(alarm));
    const [canPlay, setCanPlay] = useState(false);
    const [myInfo, setMyInfo] = useState(false);

    const audioRef = useRef(null);

    const { name } = useParams();
    const { sex } = useParams();
    const { birth } = useParams();
    const { feel } = useParams();


    const [data, setData] = useState({});

    const [Device, setDevice] = useState({});

    const [ids, setID] = useState(0);


    useEffect(() => {
        AuthMe(res => {
            setData(res);
        });
    }, []);

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);



    // 심박수
    const [values1, setValues1] = useState([]);
    const [label1, setLabel1] = useState([]);
    const [value1, setValue1] = useState(0);

    // 호흡수
    const [values2, setValues2] = useState([]);
    const [label2, setLabel2] = useState([]);
    const [value2, setValue2] = useState(0);

    // 산소불포화
    const [values3, setValues3] = useState([]);
    const [label3, setLabel3] = useState([]);
    const [value3, setValue3] = useState(0);

    

    // 움직임감지
    const [value4, setMotionDetected] = useState(0);

    let cTopic = "";
    const onMessage = (topic, message) => {
        if (cTopic !== topic) {
            return;
        }

        const msg = JSON.parse(message);
        if (msg.e) {
            procData(data, msg.e);
        }
    };

    useEffect(() => {
        if (data) {
            cTopic = `SmartMat/${data.device_sn}/Autowells-server/pub_device_data`;


            if (client) {
                client.subscribe(cTopic, error => {
                    if (error) {
                        //console.log("Subscribe to topics error", error);
                        return;
                    } else {
                        //console.log("success subscribe");
                    }
                });
            }

            addOnMessage(cTopic, onMessage);
        }
    }, [data]);


    useEffect(() => {
        loadLastData();


        AuthMe(res => {
            setMyInfo(res);
            cTopic = `SmartMat/${res.device_sn}/Autowells-server/pub_device_data`;
        });

        return () => {
            if (client) {
                client.unsubscribe(cTopic, error => {
                    if (error) {
                        //console.log("Unsubscribe error", error);
                        return;
                    }
                });
            }

            if (audio) audio.pause();

            removeOnMessage(cTopic);
        };
    }, []);

    const loadLastData = () => {
        // GetListLast({ id: id }, res => {
        //     if (res.length > 0) {
        //         const times = res.map(x => moment(x.time).format("mm:ss"));
        //         setValues1(res.map(x => x.heart));
        //         setValues2(res.map(x => x.resp));
        //         setValues3(res.map(x => x.apnea));
        //         setLabel1(times);
        //         setLabel2(times);
        //         setLabel3(times);
        //         setValue1(res[res.length - 1].heart);
        //         setValue2(res[res.length - 1].resp);
        //         setValue3(res[res.length - 1].apnea);
        //     }
        // });
    };

    useEffect(() => {}, []);

    var old_resp=0;

    const SEC = 75; // 60초 후 다음 프로세스
    const [percent, setPercent] = useState(0);

    const [date, setDate] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

    const start_date=moment(date).utc().format("YYYY-MM-DD HH:mm:ss");

     useEffect(() => {
        // 프로그레스 바의 증가량을 계산, 1000ms = 1초
        const totalMilliseconds = SEC * 1000; // 전체 시간을 밀리초로 변환
        const intervalMilliseconds = 150; // 인터벌 시간을 밀리초로 설정
        const progressIncrement = 100 / (totalMilliseconds / intervalMilliseconds); // 진행률 증가량 계산

        
        const interval = setInterval(() => {
        setPercent((prevPercent) => {      
            if (prevPercent >= 100) {
                clearInterval(interval); // 진행률이 100%에 도달하면 인터벌 정리
                sendData();
                return () => clearInterval(interval);
            }
            return prevPercent + progressIncrement;
        });
        }, intervalMilliseconds);

        // 컴포넌트가 언마운트되거나, 재렌더링 되기 전에 인터벌을 정리
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const sendData=()=>{
        var end_date=moment(Date.now()).utc().format("YYYY-MM-DD HH:mm:ss");


        navigate('/result_ready', {
            state: {
                device_sn: `K202505140001`,
                device_no: `155`,
                member_no: `153`,
                name: `${name}`,
                sex: `${sex}`,
                birth: `${birth}`,
                feel: `${feel}`,
                start: `${start_date}`,
                end: `${end_date}`
            },
        });
    }


    const procData = (data, recieveData) => {
        var heart = recieveData[0];
        var resp = recieveData[1];
        var apnea = recieveData[2];
        var state = recieveData[3];
        var fsr_sum = recieveData[4];
        var motion_detected = 0;

        if(resp==8){
            resp=old_resp;
        }else{
            old_resp=resp;
        }

        if (data) {

            if(recieveData.length >= 11){
                motion_detected = recieveData[11];

                data.motion_detected = motion_detected;
                setMotionDetected(motion_detected);
            }


            if (!data.resp_range_from) {
                data.heart_range_from = 60;
                data.heart_range_to = 100;
                data.resp_range_from = 10;
                data.resp_range_to = 20;
            }

            if (!data.online) {
                data.online = true;
                data.connectTime = moment();

                const heart_ranges = data.heart_range?.split("~");
                if (heart_ranges?.length >= 2) {
                    data.heart_range_from = heart_ranges[0];
                    data.heart_range_to = heart_ranges[1];
                }

                const resp_ranges = data.resp_range?.split("~");
                if (resp_ranges?.length >= 2) {
                    data.resp_range_from = resp_ranges[0];
                    data.resp_range_to = heart_ranges[1];
                }

                setData({ ...data });
            }
            
            const isUse = fsr_sum >= 300;
            if (isUse){
                if (canPlay && myInfo?.on_sound === "Y" && audio) {
                    if (heart < data.heart_range_from || heart > data.heart_range_to || resp < data.resp_range_from || resp > data.resp_range_to) {
                        audio.loop = true;
                        audio.play();
                    } else {
                        audio.pause();
                    }
                }
            } else {
                if (canPlay && myInfo?.on_sound === "Y" && audio) {
                    audio.pause();
                }
                heart = 0;
                resp = 0;
                apnea = 0
                state = 0;
            }
        }

        if(motion_detected === 1){
           /* heart = 0;
            resp = 0;
            apnea = 0
            state = 0;*/
        }

        const time = moment().format("mm:ss");
        setValue1(heart);
        setValue2(resp);
        setValue3(fsr_sum);
        values1.push(heart);
        values2.push(resp);
        values3.push(fsr_sum);
        setValues1([...values1.slice(-60)]);
        setValues2([...values2.slice(-60)]);
        setValues3([...values3.slice(-60)]);

        label1.push(time);
        label2.push(time);
        label3.push(time);
        setLabel1([...label1.slice(-60)]);
        setLabel2([...label2.slice(-60)]);
        setLabel3([...label3.slice(-60)]);
    };

    // 심박수 컬러
    const heartColor = "#F75C5D";

    // 호흡수 컬러
    const breathColor = "#3889ff";

    // 산소불포화지수 컬러
    const oxygenColor = "#3fd3d4";

    const getOption1 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: heartColor,
                        width: 2
                    }
                },
                formatter: `{c} BPM`,
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                boundaryGap: false,
                data: label1
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40
            },
            series: [
                {
                    name: "BPM",
                    type: "line",
                    smooth: true,
                    symbol: "none",
                    itemStyle: {
                        color: heartColor,
                        borderWidth: 20,
                        borderType: "solid",
                        opacity: 0.9
                    },
                    lineStyle: {
                        color: heartColor,
                        width: 4
                    },
                    markLine: {
                        symbol: "none",
                        data: [
                            {
                                name: t("정상"),
                                yAxis: data?.heart_range_from ? (data?.heart_range_from + data?.heart_range_to) / 2 : 80,
                                label: {
                                    color: "#3989FF"
                                },
                                lineStyle: {
                                    color: "#3989FF"
                                }
                            },
                            {
                                name: t("경고"),
                                yAxis: data?.heart_range_from ? data?.heart_range_from : 60,
                                label: {
                                    color: "#FC9D3C"
                                },
                                lineStyle: {
                                    color: "#FC9D3C"
                                }
                            },
                            {
                                name: t("위험"),
                                yAxis: data?.heart_range_to ? data?.heart_range_to : 100,
                                label: {
                                    color: "#F75C5D"
                                },
                                lineStyle: {
                                    color: "#F75C5D"
                                }
                            }
                        ],
                        label: {
                            formatter: `{b}`,
                            fontWeight: 700,
                            fontFamily: "Pretendard"
                        },
                        lineStyle: {
                            type: "solid"
                        }
                    },
                    data: values1
                }
            ]
        };
    };

    const getOption2 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: breathColor,
                        width: 2
                    }
                },
                formatter: `{c} ${t("회")}`,
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                boundaryGap: false,
                data: label2
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                min: 0,
                max: 40
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40
            },
            series: [
                {
                    name: "BPM",
                    type: "line",
                    smooth: true,
                    symbol: "none",
                    itemStyle: {
                        color: breathColor,
                        borderWidth: 20,
                        borderType: "solid",
                        opacity: 0.9
                    },
                    lineStyle: {
                        color: breathColor,
                        width: 4
                    },
                    markLine: {
                        symbol: "none",
                        data: [
                            {
                                name: t("정상"),
                                yAxis: data?.resp_range_from ? (data?.resp_range_from + data?.resp_range_to) / 2 : 15,
                                label: {
                                    color: "#3989FF"
                                },
                                lineStyle: {
                                    color: "#3989FF"
                                }
                            },
                            {
                                name: t("경고"),
                                yAxis: data?.resp_range_from ? data?.resp_range_from : 10,
                                label: {
                                    color: "#FC9D3C"
                                },
                                lineStyle: {
                                    color: "#FC9D3C"
                                }
                            },
                            {
                                name: t("위험"),
                                yAxis: data?.resp_range_to ? data?.resp_range_to : 20,
                                label: {
                                    color: "#F75C5D"
                                },
                                lineStyle: {
                                    color: "#F75C5D"
                                }
                            }
                        ],
                        label: {
                            formatter: `{b}`,
                            fontWeight: 700,
                            fontFamily: "Pretendard"
                        },
                        lineStyle: {
                            type: "solid"
                        }
                    },
                    data: values2
                }
            ]
        };
    };

    const getOption3 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: oxygenColor,
                        width: 2
                    }
                },
                formatter: `{c}`,
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                boundaryGap: false,
                data: label3
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                // min: 75,
                // max: 100
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40
            },
            series: [
                {
                    name: "BPM",
                    type: "line",
                    smooth: true,
                    symbol: "none",
                    itemStyle: {
                        color: oxygenColor,
                        borderWidth: 20,
                        borderType: "solid",
                        opacity: 0.9
                    },
                    lineStyle: {
                        color: oxygenColor,
                        width: 4
                    },
                    // markLine: {
                    //     symbol: "none",
                    //     data: [
                    //         {
                    //             name: t("정상"),
                    //             yAxis: 100,
                    //             label: {
                    //                 color: "#3989FF"
                    //             },
                    //             lineStyle: {
                    //                 color: "#3989FF"
                    //             }
                    //         },
                    //         {
                    //             name: t("경고"),
                    //             yAxis: 90,
                    //             label: {
                    //                 color: "#FC9D3C"
                    //             },
                    //             lineStyle: {
                    //                 color: "#FC9D3C"
                    //             }
                    //         },
                    //         {
                    //             name: t("위험"),
                    //             yAxis: 80,
                    //             label: {
                    //                 color: "#F75C5D"
                    //             },
                    //             lineStyle: {
                    //                 color: "#F75C5D"
                    //             }
                    //         }
                    //     ],
                    //     label: {
                    //         formatter: `{b}`,
                    //         fontWeight: 700,
                    //         fontFamily: "Pretendard"
                    //     },
                    //     lineStyle: {
                    //         type: "solid"
                    //     }
                    // },
                    data: values3
                }
            ]
        };
    };
    const isUse = value3 >= 300;
    var iconSet = 0;
    var ser=data.device_sn;
    if(ser){
        if(ser.startsWith("C",0)){
            iconSet=2;
        }else{
            iconSet=1;
        }
    }
    const heartClassName = value4 === 1 ? 'h-motion-detected' : 'heart';
    const breathClassName = value4 === 1 ? 'r-motion-detected' : 'breath';
    
    return (
        <main className="sub-contents">


            
            <audio ref={audioRef} src={ttsAudio} autoPlay />

            <div className="inner" style={{maxWidth:"1420px"}}>

                {/* <section className="monitoring_top_infos">
                    <div className="icon"></div>
                    <div className="text_b">
                        <p className="name">
                            {data.name}({t(typeSex[data.sex])} / {data.birth}){t("님의")}
                        </p>
                        <p className="desc">{t("기기정보와 생체신호를 확인하실 수 있습니다.")}</p>
                        <p className="txt">{t("기기 연결 및 등록하면 활성화 됩니다.")}</p>
                    </div>
                    <select className="select_line">
                        <option value="">{data.device_sn}</option>
                    </select>
                    
                </section> */}

                <div className="progressbar">
                    <h2>측정중</h2>
                    <Progress
                        percent={percent}
                        strokeColor={"#f08c26"}
                        showInfo={false}
                        strokeLinecap="round"
                        size={[1040,60]}
                        style={{ margin: 0 }}
                        strokeColor={{ from: '#108ee9', to: '#87d068' }}
                    />
                </div>

                <section className="monitoring_signal_list">
                    <ul>
                        <li className={heartClassName}
                        >
                            <p className="title">
                                <b>{t("심박수")}</b>(BPM)
                            </p>
                            <p className="data">
                                <strong>{value1}</strong> BPM
                            </p>
                        </li>
                        <li className={breathClassName}
                        >
                            <p className="title">
                                <b>{t("호흡수")}</b>(BPM)
                            </p>
                            <p className="data">
                                <strong>{value2}</strong> BPM
                            </p>
                        </li>
                        {/* <li className="oxygen">
                            <p className="title">
                                <b>{t("산소탈포화지수")}</b>(ODI)
                            </p>
                            <p className="data">
                                <strong>{value3}</strong> {t("회")}
                            </p>
                        </li> */}
                        <li className="oxygen">
                            <p className="title">
                                <b>{t("사용 여부")}</b>
                            </p>
                            <p className="data">
                                {/* <div class="icon_act">
                                {data.online ? (value4 === 1? <img src={UseIcon_m}  className="icon_act_fsr" alt="미사용아이콘"/> : (iconSet === 2 ? <img src={isUse ? UseIcon_c : UnUseIcon}  className="icon_act_fsr" alt="사용아이콘"/> : <img src={isUse ? UseIcon_b : UnUseIcon}  className="icon_act_fsr" alt="사용아이콘"/>)) : <img src={UnUseIcon}  className="icon_act_fsr" alt="OFF아이콘"/>}
                                </div>     */}
                                <strong>{data.online ? (isUse ? value4 === 1? t("움직임 감지") :t('사용 중') : t('미사용')) : t('OFF')}</strong>
                            </p>
                        </li>
                    </ul>
                </section>

                <section className="monitoring_time_graph">
                    <h4>{t("실시간 생체신호")}</h4>

                    <div className="graph_wrap">
                        <article className="graph_arti heart_graph">
                            <div className="top">
                                <span>
                                    <em></em> {t("심박수")}
                                </span>
                                <span>
                                    {t("정상 심박수 범위")} : {data?.heart_range_from ? data?.heart_range_from : 60}-{data?.heart_range_to ? data?.heart_range_to : 100} BPM
                                </span>
                            </div>
                            <div className="graph_box">
                                {/* <ECharts option={options} opts={{ renderer: "svg", width: "auto" }} /> */}
                                <ECharts option={getOption1()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>

                        <article className="graph_arti breath_graph">
                            <div className="top">
                                <span>
                                    <em></em> {t("호흡수")}
                                </span>
                                <span>
                                    {t("정상 호흡수 범위")} : {data?.resp_range_from ? data?.resp_range_from : 10}~{data?.resp_range_to ? data?.resp_range_to : 20}
                                    BPM
                                </span>
                            </div>
                            <div className="graph_box">
                                {/* <ECharts option={options2} opts={{ renderer: "svg", width: "auto" }} /> */}
                                <ECharts option={getOption2()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>

                        {/* <article className="graph_arti oxygen_graph">
                            <div className="top">
                                <span>
                                    <em></em> {t("산소탈포화지수")}
                                </span>                              
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption3()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article> */}

                        <article className="graph_arti oxygen_graph" >
                            <div className="top">
                                <span>
                                    <em></em> {t("입력값")}
                                </span>
                                <span>{"300 < " + data.online ? (isUse ? value4 === 1? t("움직임 감지") :t('사용 중') : t('미사용')) : ''}</span>
                            </div>
                            <div className="graph_box" >
                                <ECharts option={getOption3()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>

                        {/* <article className='graph_arti hrv_graph' style={{height: 1000,width:'100%' }}>
                            <div className="graph_box" style={{ height: 900 }}>
                                <HrvDash data={data}/>
                            </div>
                        </article> */}
                    </div>
                </section>
            </div>
        </main>
    );
};

export default Start;
